import { queryOptions } from '@tanstack/react-query';

import { queryKeys } from '@/hooks/api/query-keys';

import { getResearcherAccountSettings } from './account-settings-server';

export function accountSettingsQueryOptions(userId: string) {
  return queryOptions({
    queryKey: queryKeys.researcherAccountSettings.byUserId(userId),
    queryFn: () => getResearcherAccountSettings(),
  });
}
